var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3User(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3906 11.3971C27.7941 11.3971 29.7439 9.44873 29.7439 7.04523C29.7439 4.64173 27.7941 2.69336 25.3906 2.69336",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3906 16.127C28.1084 16.1765 28.822 16.2782 29.5246 16.4363C30.5009 16.6275 31.6751 17.0276 32.0931 17.9035C32.3599 18.4645 32.3599 19.1176 32.0931 19.68C31.6765 20.5558 30.5009 20.9546 29.5246 21.1553",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43138 11.3971C6.02788 11.3971 4.07812 9.44873 4.07812 7.04523C4.07812 4.64173 6.02788 2.69336 8.43138 2.69336",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43347 16.127C5.71572 16.1765 5.00209 16.2782 4.29947 16.4363C3.32322 16.6275 2.14897 17.0276 1.73234 17.9035C1.46422 18.4645 1.46422 19.1176 1.73234 19.68C2.14759 20.5558 3.32322 20.9546 4.29947 21.1553",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.906 17.0645C21.7762 17.0645 25.937 17.8015 25.937 20.7508C25.937 23.6988 21.8038 24.4633 16.906 24.4633C12.0344 24.4633 7.875 23.7263 7.875 20.777C7.875 17.8276 12.0082 17.0645 16.906 17.0645Z",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9046 12.8574C13.6926 12.8574 11.1172 10.282 11.1172 7.06863C11.1172 3.85663 13.6926 1.28125 16.9046 1.28125C20.1166 1.28125 22.6919 3.85663 22.6919 7.06863C22.6919 10.282 20.1166 12.8574 16.9046 12.8574Z",
    stroke: "#1F342F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3User);
export default __webpack_public_path__ + "static/media/3-user.fbf1a55b04eb6cc822ad9c6a9a99d71a.svg";
export { ForwardRef as ReactComponent };